import React from 'react';
import Sidebar from "./Sidebar";
import SEO from "../components/seo";

   const AlluminumFoilForFins = () => {

//   if (!project) return <div className="project-right">Select a project to see details.</div>;

  return (
 <>
    <SEO pageKey="aluminiumFoliForFins" />
  <style
    dangerouslySetInnerHTML={{
      __html:
        "\n    .quote-banner {\n     background: linear-gradient(to left, #000814, #0b1234, #2d3f7a);\n      color: white;\n      padding: 20px 30px;\n      border-radius: 8px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n     /*flex-wrap: wrap;*/\n    }\n    .quote-banner h5 {\n      margin: 0;\n      font-weight: 700;\n      font-style: italic;\n    }\n    .quote-banner .btn {\n      font-weight: 600;\n      text-transform: uppercase;\n      margin: 5px;\n    }\n\n    .composition-card {\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n  }\n\n  .composition-header {\n    background: #0E47A1; /* dark navy (like your image) */\n    color: #fff;\n    font-weight: 700;\n    padding: 12px 20px;\n    font-size: 1rem;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n  }\n\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ccc !important;\n    vertical-align: middle;\n  }\n\n  .table th {\n    width: 30%;\n    font-weight: 600;\n  }\n\n    .table-container {\n      background: #fff;\n      color: #000;\n      border-radius: 6px;\n      overflow: hidden;\n    }\n\n    .table {\n      margin: 0;\n      border-collapse: separate;\n      border-spacing: 0;\n      border-radius: 10px;\n      overflow: hidden;\n    }\n   .tbl_thred th{\n      background-color: #0E47A1;\n      color: #fff;\n    }\n    \n  "
    }}
  />
  <main>
    {/* breadcrumb area start */}
    <section className="ca-breadcrumb-area cream-bg-3 p-relative z-index-1 fix">
      <div className="ca-breadcrumb-shape p-absolute bre-sh-1">
        <img
          src="/static/img/shape/breadcrumn-shape.webp"
          alt=""
        />
      </div>
      <div className="ca-breadcrumb-shape p-absolute bre-sh-2">
        <img
          src="/static/img/shape/ca-line-shape.webp"
          alt=""
        />
      </div>
      <div className="container">
        <div className="ca-breadcrumb-content text-center">
          <h2 className="ca-breadcrumb-title fnw-600">Alluminium Foil For Fins</h2>
          <div className="it-breadcum-link">
            <a href="/">Home</a>
            <span>
              <i className="fa-solid fa-angle-right" />
            </span>
            <a href="/products">Products</a>
            <span>
              <i className="fa-solid fa-angle-right" />
            </span>
            <a className="active" href="#">
              Alluminium Foil For Fins
            </a>
          </div>
        </div>
      </div>
    </section>
    {/* breadcrumb area end */}
    {/* project left */}
    <div className="ca-service-lft-area pt-100 pb-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mb-30">
            <div className="ca-project-content-area">
              <div className="ca-pro-thumb-content">
                <h2 className="ca-project-thumb-title theme-black-3 fnw-600 ca-text-cap">
                  Alluminum Foil For Fins
                </h2>
                <p className="pt-16 pb-40">
                  We manufacture and supply high-performance Aluminum Fins designed for optimal heat transfer efficiency in air-conditioning, refrigeration, and heat exchanger applications. These fins provide excellent thermal conductivity, lightweight structure, and superior corrosion resistance — ensuring consistent performance and long operational life in demanding environments.
                </p>
                <div className="ca-servic-thumb br-7">
                  <img
                    className="w-100"
                    src="/static/img/portfolio/Product_Alluminium_foil_for_fins.webp"
                    alt=""
                  />
                </div>
                <br />
                <h3 className="ca-project-thumb-title-2 theme-black-3 fnw-600 ca-text-cap">
                  Manufacturing Excellence and Applications
                </h3>
                <p className="pt-16">
                  At Karmyogi Enterprises, our Aluminum Fins are produced using high-purity aluminum through precision slitting, punching, and forming processes. Each fin is manufactured with consistent thickness and surface finish to deliver maximum contact area and efficient heat exchange.
                </p>
                
                <div className="ca-about-item3 cream-bg-3 p-relative">
                  <p>
                    The aluminum material used for fins exhibits excellent thermal conductivity, high formability, and anti-corrosion properties. Suitable for use in evaporators, condensers, radiators, and heat exchangers, our fins are available in plain, corrugated, and louvered designs based on customer requirements.
                  </p>
                </div>
                <div className="ca-ab-item-check ca-ab-item-check-2 caborder-top">
                  {/* single-item */}
                  <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title ca-text-cap">
                        High Heat Transfer Efficiency
                      </h4>
                    </div>
                  </div>
                  {/* single-item */}
                  <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title ca-text-cap">
                        Lightweight & Durable Construction
                      </h4>
                    </div>
                  </div>
                  {/* single-item */}
                  <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title ca-text-cap">
                       Excellent Corrosion & Oxidation Resistance
                      </h4>
                    </div>
                  </div>
                  {/* single-item */}
                  <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title ca-text-cap">
                        Available in Plain, Louvered, and Corrugated Designs
                      </h4>
                    </div>
                  </div>
                  {/* single-item */}
                  <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title ca-text-cap">
                        Compatible with Copper & Aluminum Tubing
                      </h4>
                    </div>
                  </div>
                  {/* single-item */}
                  <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title ca-text-cap">
                        Ideal for HVAC, Refrigeration & Cooling Systems
                      </h4>
                    </div>
                  </div>
                </div>

                <h3 className="ca-project-thumb-title-2 theme-black-3 fnw-600 ca-text-cap">
                  Material Composition and Performance
                </h3>
                <p className="pt-16">
                  Our aluminum fin material is produced from high-conductivity aluminum alloys (typically AA1100, AA8011, or AA3003). These alloys combine superior heat transfer characteristics with excellent strength and formability. The material’s oxide layer provides natural protection against corrosion and wear, even in humid or saline environments.
                </p>
              </div>
            </div>
            {/* Chemical Composition Table */}
               <div className="container my-4">
              <div className="composition-card">
                <div className="composition-header">
                  Chemical Composition (Typical for AA1100 Alloy)
                </div>
                <table className="table table-bordered mb-0">
                  <thead className="tbl_thred">
                  <tr>
                    <th scope="row">Element</th>
                    <th>Percentage (%)</th>
                  </tr>
                </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Al (Aluminum)</th>
                      <td>99.00% min</td>
                    </tr>
                    <tr>
                      <th scope="row">Cu (Copper)</th>
                      <td>0.05% – 0.20%</td>
                    </tr>
                    <tr>
                      <th scope="row">Si + Fe</th>
                      <td>0.95% max</td>
                    </tr>
                    <tr>
                      <th scope="row">Mn</th>
                      <td>0.05% max</td>
                    </tr>
                    <tr>
                      <th scope="row">Zn</th>
                      <td>0.10% max</td>
                    </tr>
                    <tr>
                      <th scope="row">Others</th>
                      <td>0.15% max</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {/* <div className="container table-container mt-4">
               <div className="composition-header">
                  Available Specifications
                </div>
              <table className="table table-bordered text-center align-middle table-bordered_tbl">
                <thead className="tbl_thred">
                  <tr>
                    <th>Parameter</th>
                    <th>Range / Options</th>
                   
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Thickness</td>
                    <td>0.08 mm – 0.30 mm</td>
                  </tr>
                  <tr>
                      <td>Width</td>
                    <td>10 mm – 600 mm</td>
                  </tr>
                  <tr>
                      <td>Temper</td>
                    <td>O, H14, H18</td>
                  </tr>
                  <tr>
                    <td>Fin Type</td>
                    <td>Plain / Louvered / Corrugated</td>
                  </tr>
                  <tr>
                    <td>Surface Finish</td>
                    <td>Mill Finish / Hydrophilic Coating / Epoxy Coated</td>
                  </tr>
                  <tr>
                     <td>Coil Form</td>
                    <td>Continuous Coil / Sheet Form</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
          </div>

             {/* Sidebar */}
          <Sidebar />


        </div>
      </div>
    </div>
    <div className="ca-more-section pb-70">
      <div className="container">
        {/* <h2 class="ca-more-title theme-black-3 fnw-600 text-center mb-60">More Projects</h2>
   <div class="row">
      <div class="col-lg-4 col-md-6"> */}
        {/* single-portfolio-item */}
        {/* <div class="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30">
            <div class="ca-portfolio-img">
               <img class="w-100 br-7" src="/static/img/portfolio/portfolio-sm-1.4.webp" alt="">
            </div>
            <div class="ca-portfolio-link">
               <a href="#" class="portfolio-link portfolio-link-2"><span><img
                        src="/static/img/icon/ca-portfolio-arrow-1.1.svg" alt=""></span></a>
            </div>
            <div class="ca-portfolio-content-meta theme-bg-3 br-7">
               <p>Transportation 2024</p>
               <h4 class="ca-por-title"><a href="#">Experts in Logistics Management</a></h4>
            </div>
         </div>
      </div>
      <div class="col-lg-4 col-md-6"> */}
        {/* single-portfolio-item */}
        {/* <div class="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30">
            <div class="ca-portfolio-img">
               <img class="w-100 br-7" src="/static/img/portfolio/portfolio-sm-1.5.webp" alt="">
            </div>
            <div class="ca-portfolio-link">
               <a href="#" class="portfolio-link portfolio-link-2"><span><img
                        src="/static/img/icon/ca-portfolio-arrow-1.1.svg" alt=""></span></a>
            </div>
            <div class="ca-portfolio-content-meta theme-bg-3 br-7">
               <p>Transportation 2024</p>
               <h4 class="ca-por-title"><a href="#">Experts in Logistics Management</a></h4>
            </div>
         </div>
      </div>
      <div class="col-lg-4 col-md-6"> */}
        {/* single-portfolio-item */}
        {/*  <div class="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30">
            <div class="ca-portfolio-img">
               <img class="w-100 br-7" src="/static/img/portfolio/portfolio-sm-1.6.webp" alt="">
            </div>
            <div class="ca-portfolio-link">
               <a href="#" class="portfolio-link portfolio-link-2"><span><img
                        src="/static/img/icon/ca-portfolio-arrow-1.1.svg" alt=""></span></a>
            </div>
            <div class="ca-portfolio-content-meta theme-bg-3 br-7">
               <p>Transportation 2024</p>
               <h4 class="ca-por-title"><a href="#">Experts in Logistics Management</a></h4>
            </div>
         </div> */}
        {/* </div>
   </div>
 */}
      </div>
    </div>
  </main>
</>

);
};

export default AlluminumFoilForFins;
